'use strict';
import { BaseFilter } from './base-filter';
import template from './select-filter.html';

export class SelectFilter extends BaseFilter {
	constructor(options) {
		super(options);

		this.type = 'select';
		this.operators = this.filterOperatorsFactory.getOperatorsByType('Select');
		this.items = [];
		this.filteredItems = this.items;
		this.showHiddenValuesInSearch = this.configService.settings.dataSource.showHiddenValuesInSearch !== false;

		let searchText = '';
		let showHiddenItems = false;

		Object.defineProperty(this, 'searchText', {
			get: function () {
				return searchText;
			},
			set: (newSearchText) => {
				searchText = newSearchText;
				this.filterItems();
			},
		});

		Object.defineProperty(this, 'showHiddenItems', {
			get: function () {
				return showHiddenItems;
			},
			set: (val) => {
				showHiddenItems = val;
				this.filterItems();
			},
		});

		this.panelTemplate = template;
	}

	panelInit() {
		if (this.itemsLoaded) {
			return;
		}
		this._column.getEnumValues().then(
			function (items) {
				this.items = Array.isArray(items) ? items : [];
				this.filterItems();

				this.hiddenItemsExist =
					!this.showHiddenValuesInSearch &&
					this.items.some(function (item) {
						return item.hidden;
					});
				this.itemsLoaded = true;
			}.bind(this)
		);
	}

	getSelectedItems() {
		if (this.operatorOnForm !== this.allOperators.In.value && this.operatorOnForm !== this.allOperators.NotIn.value) {
			return [];
		}
		return this.items.filter(function (item) {
			return item.selected;
		});
	}

	getNewValue() {
		return this.getSelectedItems().map(function (item) {
			return item.value;
		});
	}

	isFormValid() {
		return (
			this.operatorOnForm === this.allOperators.IsSet.value ||
			this.operatorOnForm === this.allOperators.IsNotSet.value ||
			((this.operatorOnForm === this.allOperators.In.value || this.operatorOnForm === this.allOperators.NotIn.value) && this.getSelectedItems().length)
		);
	}

	updateTitle() {
		const selectedItemsTitle = this.getSelectedItems()
			.map((item) => item.title)
			.join(', ');
		if (this.operator === this.allOperators.In.value && selectedItemsTitle.length) {
			this.title = selectedItemsTitle;
		} else if (this.operator === this.allOperators.NotIn.value && selectedItemsTitle.length) {
			this.title = this.operatorTitle + ': ' + selectedItemsTitle;
		} else if (this.operator === this.allOperators.IsSet.value || this.operator === this.allOperators.IsNotSet.value) {
			this.title = this.operatorTitle;
		} else {
			this.title = '';
		}
	}

	setDefault() {
		this.operatorOnForm = this.allOperators.In.value;
		this.items.forEach(function (item) {
			item.selected = false;
		});
		this.filteredItems = this.items;
		this.searchText = '';
	}

	filterItems() {
		var searchText = this.searchText.toLowerCase();
		this.filteredItems = this.items.filter(function (item) {
			return item.title.toLowerCase().indexOf(searchText) >= 0 && (!item.hidden || this.showHiddenItems || this.showHiddenValuesInSearch);
		}, this);
	}

	hasValue() {
		return this.operator === this.allOperators.IsSet.value || this.operator === this.allOperators.IsNotSet.value || this.value.length > 0;
	}
}
